////////////////////////////////////////
// # GOLDEN RULE!!!! HONOR ABOVE ALL!!!!
////////////////////////////////////////
// NO NEW FILES!!!!!!!!!
////////////////////////////////////////

/*
░░░░░░░░░░░░░░░░░░░░░░░░░░░░░░░░░░░░░░░░░░░░░░░░░░░░░░░░░░░░░░░░░░░░░░░░░░░░░░░░░░░░░░░░░░░░░░░░░░░░░░░░░░░░░░░░░░░░░░░░░░░░░░░░░░░░░░░░░░░░░░░░░░░░░░░░░░░░░░░░░░░░░░░░░░░░░░░░░░░░░░░░░░░░░░░░░░░░░░░░░░░░░░░░░░░░░░░░░░
*/
// ##                                                                                                               ABOUT PAGE POD
/*
░░░░░░░░░░░░░░░░░░░░░░░░░░░░░░░░░░░░░░░░░░░░░░░░░░░░░░░░░░░░░░░░░░░░░░░░░░░░░░░░░░░░░░░░░░░░░░░░░░░░░░░░░░░░░░░░░░░░░░░░░░░░░░░░░░░░░░░░░░░░░░░░░░░░░░░░░░░░░░░░░░░░░░░░░░░░░░░░░░░░░░░░░░░░░░░░░░░░░░░░░░░░░░░░░░░░░░░░░░
*/

/**
 * BitsBound About Page - Pod Component
 *
 * Container component for the About page.
 * Since About is a static content page, this Pod simply wraps the Pea.
 *
 * TIR{ADVT}O Pattern:
 * - Trigger: Navigation to /about route
 * - Input: None
 * - Requirements{ADVT}:
 *   - D: Import AboutPea component
 *   - T: Render AboutPea
 * - Output: Rendered About page
 */

import React from 'react';
import { AboutPea } from '../pea/Bitsbound_Kings_Home_Primary_SRC_About_Lobby_Pea.js';

// ============================================
// MAIN ABOUT POD COMPONENT
// ============================================

/**
 * AboutPod - Container for About Page
 *
 * For static content pages like About, the Pod simply
 * renders the Pea without additional state management.
 */
export function AboutPod(): React.ReactElement {
  return <AboutPea />;
}

// Legacy export for backwards compatibility
export const LobbyPod = AboutPod;

export default AboutPod;

// ============================================
// END OF ABOUT PAGE POD
// ============================================
